import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';
import { wrapContentWithSeparator } from '../utils/wrapContentWithSeparator.js';

const ParagraphMd = styled.p(({ type = 'default', bold, separator, stylish, theme: { olist: { components: { text: { paragraphMd }, }, }, }, }) => css `
      ${renderTextVariations(paragraphMd, type, bold, stylish)}
      ${separator && wrapContentWithSeparator()}
    `);

export { ParagraphMd as default };
